import { useNotificationSocket } from '../../hooks/useNotificationSocket';

/**
 * Componente sin UI: monta la suscripción WebSocket de notificaciones una sola
 * vez, en un punto alto del árbol y ya autenticado. Mantener el listener aquí
 * (y no en NotificationCenter) garantiza que el tiempo real funcione aunque el
 * sidebar / la campana no estén montados en una ruta concreta.
 */
export const NotificationSocketListener = () => {
  useNotificationSocket();
  return null;
};
